import React from "react";
import { Badge } from "@/components/ui/badge";
import { Truck, CheckCircle2, Flame } from "lucide-react";

const config = {
  Preparing: {
    label: "Preparing",
    icon: Flame,
    cls: "bg-amber-100 text-amber-800 border-amber-300 dark:bg-amber-950 dark:text-amber-300 dark:border-amber-800",
    pulse: true,
  },
  Dispatched: {
    label: "Dispatched",
    icon: Truck,
    cls: "bg-blue-100 text-blue-800 border-blue-300 dark:bg-blue-950 dark:text-blue-300 dark:border-blue-800",
  },
  Delivered: {
    label: "Delivered",
    icon: CheckCircle2,
    cls: "bg-emerald-100 text-emerald-800 border-emerald-300 dark:bg-emerald-950 dark:text-emerald-300 dark:border-emerald-800",
  },
};

export default function StatusBadge({ status, testid }) {
  const c = config[status] || config.Preparing;
  const Icon = c.icon;
  return (
    <Badge variant="outline" className={`gap-1.5 font-semibold ${c.cls}`} data-testid={testid}>
      <Icon className={`h-3.5 w-3.5 ${c.pulse ? "pulse-dot" : ""}`} />
      {c.label}
    </Badge>
  );
}
